export enum DOWNVOTE_REASONS {
    // Legacy reasons
    __LEGACY_NOT_RELEVANT_FOR_CUSTOMER = 'NOT_RELEVANT_FOR_CUSTOMER',
    __LEGACY_NOT_YET_READY_TO_ORDER = 'NOT_YET_READY_TO_ORDER',
    __LEGACY_I_DONT_KNOW_WHAT_THIS_IS = 'I_DONT_KNOW_WHAT_THIS_IS',

    // Behavioural reasons
    NO_DEMAND = 'NO_DEMAND',
    CUSTOMER_BUYS_FROM_COMPETITOR = 'CUSTOMER_BUYS_FROM_COMPETITOR',
    CUSTOMER_ORDERS_FOR_PRIVATE_CONSUMPTION = 'CUSTOMER_ORDERS_FOR_PRIVATE_CONSUMPTION',
    CUSTOMER_ORDERS_AS_SPECIAL_ORDER = 'CUSTOMER_ORDERS_AS_SPECIAL_ORDER',

    // Time-based reasons
    CUSTOMER_BUYS_ONLY_FOR_PROJECTS = 'CUSTOMER_BUYS_ONLY_FOR_PROJECTS',
    CUSTOMER_BUYS_ONLY_DURING_PROMOTIONS = 'CUSTOMER_BUYS_ONLY_DURING_PROMOTIONS',

    // Category issues
    DUMMY_CATEGORY = 'DUMMY_CATEGORY',
    SEASONAL = 'SEASONAL',
    CATEGORY_TOO_BROAD = 'CATEGORY_TOO_BROAD',
    CATEGORY_TOO_SPECIFIC = 'CATEGORY_TOO_SPECIFIC',

    // Other reasons
    OTHER = 'OTHER',
}

export type CategoryBreadcrumb = {
    title: string;
    id: string;
    depth: number;
};

export function safeParseBreadcrumbs(value: string | null | undefined): CategoryBreadcrumb[] | undefined {
    try {
        return value ? JSON.parse(value) : undefined;
    } catch {
        return undefined;
    }
}

export enum InsightMarkType {
    SPOKE_TO_CUSTOMER = 'SPOKE_TO_CUSTOMER',
}

export const INSIGHT_REACTION_DISLIKE = 'dislike';
export const INSIGHT_REACTION_LIKE = 'like';
